// @mui material components
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDTypography from "components/MDTypography";

import { Component, createRef } from "react";
import { connect } from "react-redux";
import {
	ADD_POST_NEIGHBORHOOD_CHANNEL,
	ADD_POST_NEIGHBORHOOD_CITY_CHANNEL,
	DELETE_POST_NEIGHBORHOOD_CHANNEL,
	DELETE_POST_NEIGHBORHOOD_CITY_CHANNEL
} from "actions/types.js";
import {
	fetchSearchEventNeighborhoodChannels,
	fetchSearchEventNeighborhoodCityChannels
} from "actions/channel";
import { bindActionCreators } from "redux";
import ReactTags from "react-tag-autocomplete";

class Step7 extends Component {
	sendState() {
		return this.state;
	}

	constructor(props) {
		super(props);
		this.tagsRef = createRef();
		this.tagsRef2 = createRef();
	}

	handleDelete = index => {
		const { dispatch } = this.props;

		if (index >= 0) {
			dispatch({
				type: DELETE_POST_NEIGHBORHOOD_CITY_CHANNEL,
				index
			});
		}
	};

	handleAddition = channel => {
		const { dispatch } = this.props;
		dispatch({
			type: ADD_POST_NEIGHBORHOOD_CITY_CHANNEL,
			value: channel
		});
	};

	handleChannelDelete = index => {
		const { dispatch } = this.props;

		if (index >= 0) {
			dispatch({
				type: DELETE_POST_NEIGHBORHOOD_CHANNEL,
				index
			});
		}
	};

	handleChannelAddition = channel => {
		const { dispatch } = this.props;
		dispatch({
			type: ADD_POST_NEIGHBORHOOD_CHANNEL,
			value: channel
		});
	};

	onInput = query => {
		if (query?.length > 2) {
			this.props.fetchSearchEventNeighborhoodCityChannels(query);
		}
	};

	onInputCommunities = query => {
		if (query?.length > 2) {
			this.props.fetchSearchEventNeighborhoodChannels(query);
		}
	};

	render() {
		const {
			hapicolibri_city_channels,
			hapicolibri_city_channels_suggestions,
			hapicolibri_channels,
			hapicolibri_channels_suggestions,
			publishedChannelErrorMsg
		} = this.props;

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<MDTypography
						variant="h6"
						fontWeight="light"
						textAlign="center"
						mt={1.25}
						mb={1}
					>
						{
							"Veuillez sélectionner la/les ville(s), la/les communauté(s) où diffuser votre publication sur HapiColibri"
						}
					</MDTypography>
				</Grid>
				<Grid item xs={12}>
					<ReactTags
						ref={this.tagsRef}
						placeholderText="Villes ..."
						tags={hapicolibri_city_channels}
						suggestions={hapicolibri_city_channels_suggestions}
						minQueryLength={3}
						maxSuggestionsLength={10}
						onDelete={this.handleDelete}
						onAddition={this.handleAddition}
						suggestionsFilter={() => true}
						onInput={this.onInput}
						autoFocus={true}
						// onBlur={() => this.tagsRef2.current.focusInput()}
						removeButtonText="Cliquez pour retirer"
						inputAttributes={{
							autoComplete: "new-password"
						}}
					/>
					{publishedChannelErrorMsg && (
						<FormHelperText error>{publishedChannelErrorMsg}</FormHelperText>
					)}
				</Grid>
				<Grid item xs={12} mt={2.5}>
					<ReactTags
						ref={this.tagsRef2}
						placeholderText="Communautés ..."
						tags={hapicolibri_channels}
						suggestions={hapicolibri_channels_suggestions}
						minQueryLength={3}
						maxSuggestionsLength={10}
						onDelete={this.handleChannelDelete}
						onAddition={this.handleChannelAddition}
						suggestionsFilter={() => true}
						onInput={this.onInputCommunities}
						autoFocus={true}
						removeButtonText="Cliquez pour retirer"
						inputAttributes={{
							autoComplete: "new-password"
						}}
					/>
					{publishedChannelErrorMsg && (
						<FormHelperText error>{publishedChannelErrorMsg}</FormHelperText>
					)}
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		isFetching,
		publishedCities,
		publishedCityErrorMsg,
		suggestions,
		hapicolibri_city_channels,
		hapicolibri_city_channels_suggestions,
		hapicolibri_channels,
		hapicolibri_channels_suggestions,
		publishedChannelErrorMsg
	} = state.eventReducer;
	return {
		suggestions,
		publishedCities,
		publishedCityErrorMsg,
		isFetching,
		hapicolibri_city_channels: Object.values(hapicolibri_city_channels),
		hapicolibri_city_channels_suggestions: Object.values(
			hapicolibri_city_channels_suggestions
		),
		hapicolibri_channels: Object.values(hapicolibri_channels),
		hapicolibri_channels_suggestions: Object.values(
			hapicolibri_channels_suggestions
		),
		publishedChannelErrorMsg
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchSearchEventNeighborhoodCityChannels,
			fetchSearchEventNeighborhoodChannels
		},
		dispatch
	);
	return { ...actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true
})(Step7);
